<template>
  <div />
</template>

<script>
import qs from 'querystringify'

export default {
  props: {
    /** ページ表示後、即リダイレクトするか。 */
    immediately: {
      type: Boolean,
      required: true,
    },
  },
  async created() {
    if (this.immediately) {
      await this.redirect()
    }
  },
  methods: {
    /** DBマスタデータを取得する。 */
    async getMasterData(token) {
      const res = await this.$axios.get(
        `${this.$appConfig.CommonApiUrl}/masters`,
        {
          headers: {
            Authorization: token,
          },
        },
      )
      return res.data
    },
    /** 特定の画面にリダイレクトする。 */
    async redirect() {
      window.location.href = await (async() => {
        const token = this.$store.getters['auth/authorization']
        if (this.$store.getters['auth/isMyoridge']) {
          return `${this.$appConfig.ScreenUrl.settingMenu}/?token=${token}`
        }
        const masterData = await this.getMasterData(token)
        // 以前ログイン時に最後にアクセスしたURLを取得する。
        const locationHistory = localStorage.getItem(
          this.$appConfig.localStorageKeys.locationHistory,
        )
        // 初回ログイン時（ローカルストレージに履歴のURLが保存されていない場合）、各トップ画面へ遷移する。
        // なお、各種設定サービスを表示する権限がある場合、優先して表示する。
        const url = locationHistory
          ? locationHistory
          : (() => {
              if (masterData?.company?.isUseSmallLot) {
                // 工程管理サービスを表示する権限がある場合
                localStorage.setItem(
                  this.$appConfig.localStorageKeys.serviceID,
                  this.$appConfig.serviceID.smallLot,
                )
                return this.$appConfig.ScreenUrl.scheduleOrder
              } else if (masterData?.company?.isUsePurchase) {
                // 受発注管理サービスを表示する権限がある場合
                localStorage.setItem(
                  this.$appConfig.localStorageKeys.serviceID,
                  this.$appConfig.serviceID.purchase,
                )
                return this.$appConfig.ScreenUrl.purchaseOrderList
              } else if (masterData?.company?.isUseInventory) {
                // 在庫管理サービスを表示する権限がある場合
                localStorage.setItem(
                  this.$appConfig.localStorageKeys.serviceID,
                  this.$appConfig.serviceID.inventory,
                )
                return this.$appConfig.ScreenUrl.ship
              } else {
                localStorage.setItem(
                  this.$appConfig.localStorageKeys.serviceID,
                  this.$appConfig.serviceID.base,
                )
                return this.$appConfig.ScreenUrl.settingMenu
              }
            })()
        const query = qs.parse(location.search)
        if (query.back) {
          try {
            return decodeURIComponent(query.back)
          } catch (e) {
            return url
          }
        }
        return url
      })()
    },
  },
}
</script>

<style lang="scss" scoped></style>
